import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useLicenseWarning } from '../../services/license-status';

// Manager only. A cashier or waiter can do nothing about a licence and is
// mid-service — same reasoning as LocalServerUpdateButton's role gate, narrowed
// further because renewing is the manager's call, not the floor staff's.
const ALLOWED_ROLES = ['manager'];

/**
 * Shown from LICENSE_WARN_DAYS before the licence expires, and throughout the
 * grace window once it has. Fed by the X-License-Warning header that both the
 * cloud gate and the local server's licenseGate emit on every response — so it
 * also works on a POS served by a local server with the cloud unreachable.
 */
export default function LicenseExpiryBanner() {
    const days = useLicenseWarning();
    const { user } = useAuth();

    if (days === null || !user || !ALLOWED_ROLES.includes(user.role)) return null;

    const urgent = days <= 7;
    const label = days < 0
        ? `Licence expirée depuis ${-days} jour${-days > 1 ? 's' : ''} — renouvelez-la pour éviter le blocage`
        : days === 0
            ? "Licence expire aujourd'hui"
            : `Licence expire dans ${days} jour${days > 1 ? 's' : ''}`;

    return (
        <div
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium ${
                urgent ? 'bg-red-50 text-red-700' : 'bg-orange-50 text-orange-700'
            }`}
            title={label}
        >
            <AlertTriangle className="h-3.5 w-3.5 flex-shrink-0" />
            <span className="hidden 2xl:inline">{label}</span>
        </div>
    );
}
